import React from 'react';
import { Box, Container, Typography } from '@mui/material';

export type CircleItem = {
  label: string;
  url?: string;
  image?: string;
};

export type CirclesSettings = {
  enabled?: boolean;
  title?: string;
  items?: CircleItem[];
};

interface Props {
  circles: CirclesSettings | undefined;
  resolvePublicUrl: (p?: string) => string | undefined;
}

const CirclesSection: React.FC<Props> = ({ circles, resolvePublicUrl }) => {
  if (!circles || circles.enabled === false) return null;
  const items = Array.isArray(circles.items) ? circles.items : [];
  if (items.length === 0) return null;
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
      {circles.title && (
        <Typography variant="h5" fontWeight={800} sx={{ mb: 2 }}>
          {circles.title}
        </Typography>
      )}
      <Box sx={{ display: 'flex', overflowX: 'auto', gap: 3, pb: 1, WebkitOverflowScrolling: 'touch' }}>
        {items.map((it, idx) => {
          const img = it.image ? resolvePublicUrl(it.image) : undefined;
          const content = (
            <Box sx={{ textAlign: 'center', minWidth: 160 }}>
              <Box sx={{
                width: 140,
                height: 140,
                borderRadius: '50%',
                bgcolor: '#f5f7fb',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)',
                display: 'grid',
                placeItems: 'center',
                overflow: 'hidden',
                mx: 'auto',
              }}>
                {img ? (
                  <Box component="img" src={img} alt={it.label} sx={{ width: '70%', height: '70%', objectFit: 'contain' }} />
                ) : (
                  <Box sx={{ width: '70%', height: '70%', borderRadius: '50%', bgcolor: 'grey.200' }} />
                )}
              </Box>
              <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 1.5 }}>
                {it.label}
              </Typography>
            </Box>
          );
          return it.url ? (
            <a href={it.url} target="_blank" rel="noopener noreferrer" key={idx} style={{ textDecoration: 'none', color: 'inherit' }}>
              {content}
            </a>
          ) : (
            <Box key={idx}>{content}</Box>
          );
        })}
      </Box>
    </Container>
  );
};

export default CirclesSection;
